import { useCallback, useEffect, useState } from 'react';
import { Modal, Button, Popconfirm, Input } from 'antd';
import { Container } from '@/ui';
import { useTranslation } from 'react-i18next';
import { Label, Space } from '@/features/constructorCommon/styled';
import { useProductDescription } from '@/features/constructorProducts/hooks/useProductDescription';

export const UpdateProductDescriptionModal = ({
  open,
  onClose,
  selectedItem,
  productDescriptions
}) => {
  const { t } = useTranslation();
  const { handleUpdate } = useProductDescription();
  const [data, setData] = useState({});

  useEffect(() => {
    const foundItem = productDescriptions?.find((i) => i?.id === selectedItem?.key);

    if (foundItem) setData(foundItem);
  }, [productDescriptions, selectedItem, open]);

  const onChange = useCallback((e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  }, []);

  const handleClose = useCallback(() => {
    setData({});
    onClose();
  }, [onClose]);

  const handleUpdateDescriptionSection = useCallback(() => {
    handleUpdate({
      id: selectedItem.key,
      ...data
    }).then(() => {
      handleClose();
    });
  }, [handleUpdate, selectedItem, data, handleClose]);

  return (
    <Modal
      open={open}
      onCancel={handleClose}
      title={t('Update collapsed description section')}
      footer={[
        <Button key='back' onClick={handleClose}>
          {t('Cancel')}
        </Button>,
        <Popconfirm
          title={t('Update collapsed description section')}
          description={t('Are you sure you want to update the collapsed description section?')}
          okText={t('Yes')}
          cancelText={t('No')}
          onConfirm={() => handleUpdateDescriptionSection()}
        >
          <Button type='primary' style={{ marginLeft: '4px' }}>
            {t('Update')}
          </Button>
        </Popconfirm>
      ]}
    >
      <Container $marginTop={16} $marginBottom={10}>
        <Label>{t('Title')}</Label>
        <Input name='name' value={data.name} onChange={onChange} />
        <Space />
        <Label>{`${t('Title')} (RU)`}</Label>
        <Input name='name_RU' value={data.name_RU} onChange={onChange} />
        <Space />
        <Label>{`${t('Title')} (LV)`}</Label>
        <Input name='name_LV' value={data.name_LV} onChange={onChange} />
        <Space />
        <Label>{t('Description')}</Label>
        <Input name='descriptions' value={data.descriptions} onChange={onChange} />
        <Space />
        <Label>{`${t('Description')} (RU)`}</Label>
        <Input name='descriptions_RU' value={data.descriptions_RU} onChange={onChange} />
        <Space />
        <Label>{`${t('Description')} (LV)`}</Label>
        <Input name='descriptions_LV' value={data.descriptions_LV} onChange={onChange} />
        <Space />
      </Container>
    </Modal>
  );
};
